import Select from '@/components/Form/Select.jsx'

import {
    PropertiesController,
    usePropertiesController,
} from './PropertiesController.jsx'

export default function PropertiesControllerSelect({
    className,
    style,
    disabled,
    hidden,
    label,
    labelSuffix,
    prop,
    readOnly,
    required,
    value,
    ...props
}) {
    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop,
        readOnly,
        required,
        value,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            error={p.error}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <Select
                style={{display: 'block'}}
                allowClear
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={p.value}
                onChange={p.onChange}
                {...props}
            />
        </PropertiesController>
    )
}
